import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from "../../../data-access/role.service";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface UserResponse {
  email: string
  username: string
  display_name: string
  given_name: string
  family_name: string
  user_id: number
  role_id: number
  organization_id?: number
  subject_id?: number
  unit_id?: number
  course_id?: number
  date: string
}
@Component({
    selector: 'roleAssignees',
    templateUrl: './roleAssignees.html',
    standalone: false
})
export class RoleAssigneesComponent implements OnInit {
  constructor(
    private router: Router,
    private roleService: RoleService,
    private route: ActivatedRoute,
  ) {}
  title: string = "";
  users: UserResponse[] = []
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }, {
    text: 'User Roles',
    route: 'dashboard/UserManagement/UserRoles'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.roleService.getRoleDetail(params['id']).subscribe((response) => {
        this.title = response.result.name;
      })
      this.roleService.listRoleAssignees(params['id']).subscribe((response) => {
        if(response.success)
          this.users = response.result
        console.log(this.users)
      })
    })
  }
  userManagementMenu() {
    this.router.navigate(['dashboard/UserManagement']);
  }
  userRoleList() {
    this.router.navigate(['dashboard/UserManagement/UserRoles']);
  }
}
